
export default [
    {
        path: '/admin/monthly-allowances',
        name: 'monthly-allowances',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/monthly-allowance/index.vue')
    }
]